<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="700px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div class="version-table">
        <span class="v-label">{{ label }}</span>
        <el-table :data="currentVersionList" border style="width: 70%" empty-text="暂无版本">
          <el-table-column prop="versionNumber" label="版本号" width="120"> </el-table-column>
          <el-table-column prop="forceUpdate" label="强制升级" width="80">
            <template slot-scope="scope">{{ scope.row.forceUpdate | isOrNot }}</template>
          </el-table-column>
          <el-table-column prop="versionType" label="版本类型">
            <template slot-scope="scope"
              ><span>{{ scope.row.versionType | versionType }}</span></template
            >
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope"
              ><span>{{ scope.row.status | status }}</span></template
            >
          </el-table-column>
        </el-table>
      </div>

      <el-form :model="dataForm" ref="dataForm" :rules="rules">
        <el-form-item
          :label="uploadlabel"
          required
          :label-width="formLabelWidth"
          :class="{ 'name-unrequired': appMarketLink !== '' }"
          v-if="type === 4 || (type === 5 && (versionStatus === 1 || versionStatus === 2))"
        >
          <!-- <el-input v-model="filename" v-if="filename!==''" ></el-input> -->
          <div class="upload-box">
            <el-upload
              ref="upload"
              accept=".exe,.mis,.apk,.zip,.rar,.tar,.7z"
              action="#"
              :multiple="false"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="changeUpload"
            >
              <div class="upload-input" slot="trigger">
                <div style="color: #c0c4cc">
                  <el-tooltip
                    class="name-box"
                    v-if="filename && filename.length > 50"
                    effect="dark"
                    :content="filename"
                    placement="top-start"
                  >
                    <span class="name-box">
                      {{ filename | ellipsis(50) }}
                    </span>
                  </el-tooltip>
                  <div v-else>
                    {{ filename || filename2 || '请选择版本安装文件' }}
                  </div>
                </div>
              </div>
            </el-upload>
            <i
              class="el-icon-delete-solid"
              @click="deleted()"
              v-if="(type !== 4 && filename2 !== '') || filename !== ''"
            ></i>
          </div>
        </el-form-item>
        <!-- <el-form-item label="版本号" :label-width="formLabelWidth">
                    <el-input v-model="dataForm.version" placeholder="版本号" :disabled="true"></el-input>
                </el-form-item> -->
        <el-form-item label="版本号" v-if="type === 4" :label-width="formLabelWidth">
          <span>V</span>
          <el-input-number
            size="small"
            v-model="num1"
            controls-position="right"
            @change="handleChange1"
            :min="0"
            :max="1000"
            class="number-input-version"
          ></el-input-number>
          <span>.</span>
          <el-input-number
            size="small"
            v-model="num2"
            controls-position="right"
            @change="handleChange2"
            :min="0"
            :max="1000"
            class="number-input-version"
          ></el-input-number>
          <span>.</span>
          <el-input-number
            v-model="num3"
            size="small"
            controls-position="right"
            @change="handleChange3"
            :min="0"
            :max="1000"
            class="number-input-version"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="强制升级" :label-width="formLabelWidth">
          <el-radio-group v-model="dataForm.force">
            <el-radio :label="0">否(默认)</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
          <el-input
            type="textarea"
            :rows="4"
            maxlength="100"
            placeholder="请填写备注"
            show-word-limit
            v-model="dataForm.remark"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="更新内容" :label-width="formLabelWidth" prop="desc">
          <el-input
            type="textarea"
            :rows="4"
            maxlength="500"
            placeholder="请输入更新内容，最多500字"
            show-word-limit
            v-model="dataForm.desc"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <MultiLanguage ref="multiLanguageRef" :type="type"></MultiLanguage>

      <div slot="footer" class="dialog-footer dflex">
        <div class="progress-percent">
          <span v-if="progressFlag"
            >文件上传中：<el-progress :percentage="progressPercent"></el-progress
          ></span>
        </div>
        <span v-if="showError" class="error-msg">{{ errorMsg }}</span>
        <el-button :loading="submiting" @click="visible = false">取 消</el-button>
        <el-button type="primary" :loading="submiting" @click="submitForm('dataForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- <el-dialog
            title="文件上传进度"
            :visible.sync="progressFlag"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :center="true"
            width="200px">
            <el-progress :percentage="progressPercent"></el-progress>
          </el-dialog> -->
  </div>
</template>

<script>
import MultiLanguage from '@/components/MultiLanguage'
export default {
  props: ['vstatus', 'pstatus', 'productNumber', 'productId', 'productName', 'productType'],
  components: {
    MultiLanguage
  },
  data() {
    return {
      versionStatus: 1, // 版本状态
      waitTestVersionInfo: null,
      currentVersionList: [],
      showError: false,
      appMarketLink: '',
      errorMsg: '',
      num1: '',
      num2: '',
      num3: '', // 用不到，最后删除
      title: '编辑版本',
      label: '当前版本',
      type: '',
      uploadlabel: '',
      progressFlag: false, // 进度条初始值隐藏
      progressPercent: 0, // 进度条初始值
      tipInfo: ' 产品编号 | 产品名称 | 客户名称 ',
      submiting: false,
      visible: false,
      fileList: [],
      langList: [], // 多语言添加的列表
      languageSendList: [],
      percent: 0,
      filename: '',
      filename2: '', // 编辑的时候后台返回的文件名,点击删除按钮的时候，要清空
      filename2Bak: '', // 编辑的时候后台返回的文件名,点击删除按钮的时候，备份知道原来是否有安装包
      currentFile: '',
      originVersion: 'V0.0.0', // 源版本号
      dataForm: {
        info: '', // 产品信息
        desc: '', // 更新内容
        remark: '',
        force: 0, // 是否强制升级 0否（默认） 1是
        version: ''
      },
      dataList: [],
      rules: {
        type: [{ required: true, message: '请选择产品系列', trigger: 'change' }],
        info: [{ required: true, message: '请选择产品信息', trigger: 'change' }],
        remark: [
          { required: false, message: '请输入备注', trigger: 'blur' },
          { max: 100, message: '最多100个字符', trigger: 'blur' }
        ],
        desc: [
          { required: true, message: '请输入更新内容', trigger: 'blur' },
          { max: 500, message: '最多500个字符', trigger: 'blur' }
        ]
      },
      typeOptions: [],
      formLabelWidth: '120px'
    }
  },
  mounted() {},
  methods: {
    init(info, appMarketLink) {
      this.showError = false
      this.dataForm.id = info.id
      this.visible = true
      if (!this.progressFlag) {
        this.progressPercent = 0
      }

      if (this.vstatus === 'add' || this.pstatus === 'add') {
        this.getVersionInfo()
        this.type = 4
        this.title = '新版本'
        this.label = '上个版本'
        this.uploadlabel = '浏览'
        this.$nextTick(() => {
          this.$refs.upload.clearFiles()
          this.$refs.dataForm.resetFields()
          this.dataForm.desc = ''
          this.dataForm.remark = ''
          this.num1 = ''
          this.num2 = ''
          this.num3 = ''
          this.filename = ''
          this.filename2 = ''
          this.filename2Bak = ''
          this.$refs.multiLanguageRef.init('')
        })
      } else if (this.vstatus === 'edit') {
        this.appMarketLink = appMarketLink
        this.versionStatus = info.status
        this.filename = ''
        const versionArr = info.versionNumber.split('.')
        if (versionArr.length > 0) {
          this.num1 = versionArr[0].substr(1)
          this.num2 = versionArr[1]
          this.num3 = versionArr[2]
        }
        this.currentVersionList = []
        const obj = {
          versionType: info.versionType,
          forceUpdate: info.forceUpdate,
          versionNumber: info.versionNumber,
          status: info.status
        }
        this.currentVersionList.push(obj)
        this.type = 5
        this.getversionMultiLanguage()
        this.title = '编辑版本'
        this.label = '当前版本'
        this.uploadlabel = '安装文件'
        this.dataForm.force = info.forceUpdate
        this.dataForm.desc = info.updateContent
      }
    },
    handleChange1(value) {},
    handleChange2(value) {},
    handleChange3(value) {},

    // 获取产品的最新版本信息
    getVersionInfo() {
      this.$http({
        url: this.$http.adornUrl('/api/app/getLatestProductVersion'),
        method: 'get',
        params: this.$http.adornParams({
          productId: this.productId
        })
      })
        .then(res => {
          if (res.resp_code === 0) {
            this.appMarketLink = res.data.appMarketLink === null ? '' : res.data.appMarketLink
            this.versionStatus = res.data.status
            if (res.data.versionNumber === null) {
              // 还没有上传版本
              this.currentVersionList = []
            } else {
              this.originVersion = res.data.versionNumber
              this.currentVersionList = []
              const obj = {
                versionType: res.data.versionType,
                forceUpdate: res.data.forceUpdate,
                versionNumber: res.data.versionNumber,
                status: res.data.status
              }
              this.currentVersionList.push(obj)
            }
          } else {
            this.currentVersionList = []
            this.$message.error(res.resp_msg)
          }
        })
        .catch(() => {
          this.currentVersionList = []
        })
    },
    // 查询版本多语言信息
    getversionMultiLanguage() {
      this.tabLoding = true
      this.$http({
        url: this.$http.adornUrl('/api/app/getProductVersionMultiLanguage'),
        method: 'get',
        params: this.$http.adornParams({
          versionId: this.dataForm.id
        })
      })
        .then(res => {
          const data = res.data
          if (data && res.resp_code === 0) {
            this.verinfo = res.data
            this.langList = data.list
            this.dataForm.productNumber = this.verinfo.productNumber
            this.dataForm.name = this.verinfo.productName
            this.dataForm.customer = this.verinfo.userName
            this.dataForm.describe = this.verinfo.productDescribe
            this.dataForm.remark = this.verinfo.note
            this.$refs.multiLanguageRef.init(this.langList)
            this.filename2 = this.verinfo.fileName || ''
            this.filename2Bak = this.verinfo.fileName || ''
            this.dataForm.id = this.verinfo.id
          } else {
            this.langList = []
            this.$message.error(res.resp_msg)
          }
        })
        .catch(() => {})
    },
    // 如果有安装包，删除操作
    deleted() {
      this.filename = ''
      this.filename2 = ''
    },
    // 选择产品系列
    // typeChange() {
    //   this.dataForm.info = ''
    //   this.getProList()
    // },
    // 获取产品列表
    // getProList() {
    //   this.$http({
    //     url: this.$http.adornUrl('/api/app/getProductInfo'),
    //     method: 'get',
    //     params: this.$http.adornParams({
    //       pageNum: 1,
    //       pageSize: 10000,
    //       execEnd: '', // 运行端
    //       productName: '',
    //       productSeries: this.dataForm.type,
    //       userName: ''
    //     })
    //   }).then(res => {
    //     this.infoLists = []
    //     const data = res.data
    //     if (data && res.resp_code === 0) {
    //       const infoLists = data.list
    //       infoLists.forEach(item => {
    //         this.infoLists.push({
    //           id: item.id,
    //           showValue: item.productNumber + ' | ' + item.productName + ' | ' + item.userName,
    //           validVersionNumber: item.validVersionNumber,
    //           disabled: false,
    //           productNumber: item.productNumber,
    //           productName: item.productName,
    //           userName: item.userName
    //         })
    //       })
    //     } else {
    //       this.infoLists = []
    //     }
    //   }).catch(err => {
    //     console.log('err => ', err)
    //     this.infoLists = []
    //   })
    // },
    // selectPro(e) {
    //   this.dataList.forEach(item => {
    //     this.originVersion = item.versionNumber
    //   })
    // },
    // 获取产品系列
    // getTypes() {
    //   this.$http({
    //     url: this.$http.adornUrl('/api/app/getProductSeries'),
    //     method: 'get'
    //   }).then(res => {
    //     const data = res.data
    //     if (data && res.resp_code === 0) {
    //       this.typeOptions = data.list
    //       // if (this.typeOptions.length > 0) {
    //       //   this.dataForm.type = this.typeOptions[0]
    //       //   this.getProList()
    //       // }
    //     } else {
    //       this.typeOptions = []
    //       this.$message.error(res.resp_msg)
    //     }
    //   }).catch(() => {
    //     this.typeOptions = []
    //   })
    // },
    // 文件状态改变
    changeUpload(file) {
      if (file.size > 600 * 1024 * 1024) {
        this.$message.error('安装文件大小最大支持600M，所选文件超出限制')
        return
      }
      this.currentFile = file.raw
      this.filename = file.raw.name || ''
      this.filename2 = '' // 上传新文件了，就置空原来后台返回的filename2
      // const name = file.name

      // if (!/_V\d+_\d+_\d+\./.test(name)) {
      //   this.$message({
      //     message: '安装包命名不合规范，可参考：12345672625P200_V1_0_0.apk',
      //     type: 'error',
      //     showClose: true,
      //     duration: 5000
      //   })
      // } else {
      //   const nameArr = name.split('_')// ["RMS","VGG","V1","0","0.apk"]
      //   const versionArr = nameArr.slice(nameArr.length - 3, nameArr.length) // ["V1","0","0.apk"]
      //   this.filename = file.raw.name
      //   const version = versionArr.join('.')
      //   const index = version.lastIndexOf('.')
      //   const versionName = version.slice(0, index)
      //   this.dataForm.version = versionName
      //   const nameVersionArr = versionName.split('.')
      //   this.num1 = nameVersionArr[0].substr(1)
      //   this.num2 = nameVersionArr[1]
      //   this.num3 = nameVersionArr[2]
      // }
    },
    compareVersion(v1, v2) {
      v1 = v1.split('.')
      v2 = v2.split('.')
      const len = Math.max(v1.length, v2.length)

      while (v1.length < len) {
        v1.push('0')
      }
      while (v2.length < len) {
        v2.push('0')
      }

      for (let i = 0; i < len; i++) {
        const num1 = parseInt(v1[i])
        const num2 = parseInt(v2[i])

        if (num1 > num2) {
          return 1
        } else if (num1 < num2) {
          return -1
        }
      }
      return 0
    },
    getSendlist() {
      this.langList = this.$refs.multiLanguageRef.langList
      this.languageSendList = []
      this.langList.forEach(item => {
        const obj = {
          updateContent: item.multiLanguageupdateContent,
          languageKey: item.languageKey
        }
        this.languageSendList.push(obj)
      })
    },
    // 添加新版本，没有上传安装包，直接保存文件之外的信息
    addVersionSave() {
      this.$http({
        url: this.$http.adornUrl('/api/v1/ota/save'),
        method: 'post',
        data: this.$http.adornData({
          productId: this.productId,
          versionNumber: this.dataForm.version,
          forceUpdate: this.dataForm.force,
          updateContent: this.dataForm.desc,
          note: this.dataForm.remark,
          list: this.languageSendList.length === 0 ? null : this.languageSendList
        })
      })
        .then(res => {
          if (res.resp_code === 0) {
            this.$message.success('新增版本成功')
            // 需要查询一次版本列表
            this.visible = false
            this.$emit('refreshDataList')
          } else {
            this.$message.error(res.resp_msg)
          }
        })
        .catch(() => {
          console.log('save-failed')
        })
    },
    // 没有上传安装包，直接保存文件之外的信息
    updateSaveVersion(deleteFile) {
      this.$http({
        url: this.$http.adornUrl('/api/app/updateProductVersion'),
        method: 'post',
        data: this.$http.adornData({
          delete: deleteFile, // delete传 0就是不删除原来的安装包 delete传 1就是删除原来的安装包  delete传2 就是上传新的安装包
          fileName: this.filename2,
          versionId: this.dataForm.id,
          updateContent: this.dataForm.desc,
          forceUpdate: this.dataForm.force,
          list: this.languageSendList.length === 0 ? null : this.languageSendList,
          note: this.dataForm.remark
        })
      })
        .then(res => {
          if (res.resp_code === 0) {
            this.visible = false
            this.$message.success('编辑版本成功')
            // 需要查询一次版本列表
            this.$emit('refreshDataList')
          } else {
            this.$message.error(res.resp_msg)
          }
        })
        .catch(() => {
          console.log('save-failed')
        })
    },
    compare() {
      // 判断版本号是否比原来的新
      if (this.originVersion !== '') {
        const old = this.originVersion.substr(1)
        // const newV = this.dataForm.version.substr(1)
        const newV = this.num1 + '.' + this.num2 + '.' + this.num3

        const compare = this.compareVersion(newV, old)
        if (compare === 0 || compare === -1) {
          this.$message({
            message: '版本号需要高于上个版本',
            type: 'error',
            showClose: true,
            duration: 5000
          })
        }
        return compare
      }
    },
    // 判断多语言的重复
    judgeLanguageRepeat() {
      const langs = []
      this.langList.forEach(item => {
        langs.push(item.languageKey)
      })
      const newList = [...new Set(langs)]
      if (newList.length !== langs.length) {
        return true
      }
      return false
    },
    submitForm(formName) {
      const hasLanguageEmpty = this.$refs.multiLanguageRef.submit()
      if (hasLanguageEmpty) {
        // 多语言有为空的情况
        return
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 多语言
          this.langList = this.$refs.multiLanguageRef.langList
          if (this.judgeLanguageRepeat()) {
            this.showError = true
            this.errorMsg = '多语言类型选项重复'
            return
          }
          if (this.langList.length > 14) {
            this.$message.error('多语言不得超过14个')
            return
          }
          // 校验当前产品是否有正在上传的包
          const uploadingPnList = this.$store.state.uploadingPnList || {}
          const failedPnList = this.$store.state.failedPnList || {}
          let replaceId = 0
          if (uploadingPnList[this.productNumber]) {
            this.$message({
              message: '当前产品存在未完成的安装包上传任务，请等待任务结束后再上传',
              type: 'error',
              duration: 3000
            })
            return
          }

          if (failedPnList[this.productNumber]) {
            replaceId = failedPnList[this.productNumber]
            //  return
          }

          // 接下来
          const theNext = () => {
            // const pnNames = []
            // const modelNames = []
            // for (const key in modelAndPn) {
            //   modelNames.push(key)
            //   pnNames.push(...modelAndPn[key])
            // }
            this.dataForm.version = 'V' + this.num1 + '.' + this.num2 + '.' + this.num3
            this.getSendlist()
            const uploadObj = {
              // 文件
              file: this.currentFile,
              // 业务参数
              params: {
                proNum: this.productNumber,
                proName: this.productName,
                proType: this.productType,
                versionNumber: this.dataForm.version,
                updateContent: this.dataForm.desc,
                remark: this.dataForm.remark,
                productId: this.dataForm.id,
                forceUpdate: this.dataForm.force,
                list: this.languageSendList,
                type: this.type, // 4新增 5编辑
                versionId: this.type === 5 ? this.dataForm.id : ''
              },
              // 其他参数
              replaceId
            }
            if (this.type === 4) {
              // 新增版本
              this.addVersionClick(uploadObj)
            } else if (this.type === 5) {
              // 编辑版本
              this.updateVersionClick(uploadObj)
            }
          }

          if (replaceId) {
            this.$confirm('当前所选产品存在已取消或失败的安装包上传任务，确认替换任务吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                theNext()
              })
              .catch(() => {})
          } else {
            theNext()
          }
          // this.progressFlag = true
          // this.submiting = true

          // if (this.type === 4) {
          //   // 新增
          //   if (this.dataForm.desc.trim() === '') {
          //     this.$message.error('更新内容不能是空格')
          //     return
          //   }
          //   this.add()
          // } else {
          //   // 编辑
          //   this.update()
          // }

          // const formdata = new FormData()
          // formdata.append('files', this.currentFile)
          // formdata.append('force_update', this.dataForm.force)
          // formdata.append('product_id', this.dataForm.id)
          // formdata.append('update_content', this.dataForm.desc.trim())
          // formdata.append('version_number', this.dataForm.version)
          // formdata.append('note', this.dataForm.remark.trim())
          // this.languageSendList.forEach((item, i) => {
          //   formdata.append(`list[${i}].languageKey`, item.languageKey)
          //   formdata.append(`list[${i}].updateContent`, item.updateContent)
          // })
          // this.$http({
          //   url: this.$http.adornUrl('/api/app/insertProductVersion'),
          //   method: 'post',
          //   timeout: 1000 * 300,
          //   headers: {
          //     Authorization: this.$cookie.get('token')
          //   },
          //   data: formdata,
          //   onUploadProgress: progressEvent => {
          //     // progressEvent.loaded:已上传文件大小
          //     // progressEvent.total:被上传文件的总大小
          //     // 进度条
          //     that.progressPercent = ((progressEvent.loaded / progressEvent.total) * 100) | 0
          //     if (that.progressPercent === 100) {
          //       that.progressFlag = false
          //     }
          //   }
          // }).then(res => {
          //   this.submiting = false
          //   if (res.resp_code === 0) {
          //     this.visible = false
          //     this.$emit('refreshDataList')
          //     this.$message({
          //       message: '上传成功',
          //       type: 'success'
          //     })
          //   } else {
          //     this.$message.error(res.resp_msg)
          //   }
          // }).catch(() => {
          //   this.submiting = false
          // })
        } else {
          return false
        }
      })
    },
    // 那新增版本的时候，判断是否有未开启测试的版本，如果有，需要先把原来的待测试版本删掉
    exitsWaitTesting() {
      return this.$http({
        url: this.$http.adornUrl('/api/app/getProductVersionWaitTest'),
        method: 'get',
        params: this.$http.adornParams({
          productId: this.productId
        })
      })
    },
    // 新增点击确认按钮
    addVersionClick(uploadObj) {
      if (this.appMarketLink === '' && this.filename === '') {
        // 没有市场链接，没上传安装包，错误信息，请上传安装包,
        this.$message.error('请选择新的版本安装文件')
        return
      }
      const compare = this.compare()
      if (compare === 1) {
        // 版本号OK
        this.addVersionSure(uploadObj)
      }
    },
    // 各种限制条件都通过了
    addVersionSure(uploadObj) {
      if (this.filename === '') {
        // 没上传安装包，直接调用/save接口，不需要文件断点续传的接口
        this.addVersionSave()
      } else {
        this.$store.commit('addUpload', uploadObj)
        this.visible = false
      }
    },
    // 编辑版本
    // 新文件filename
    // 后台返回的原来的文件 filename2
    // filenameBak 后台返回的原来的文件的备份，因为点击删除按钮时，会把filename2清空
    // 如果上传新文件了filename有值，就要调用文件断点续传upload，
    // 如果没有新文件，
    // 且没有删原本的文件，直接保存了，直接调用/updateProductVersion
    // 删了原本的文件，则需要判断是否有市场链接，有市场链接，直接调用/updateProductVersion,无市场链接，需给出提示
    updateVersionClick(uploadObj) {
      if (this.filename !== '') {
        // 有新的安装包，就要调用断点续传接口
        this.$store.commit('addUpload', uploadObj)
        this.visible = false
      } else {
        // 没有新的安装包
        if (this.filename2 !== '') {
          // 没删原本的文件,直接保存
          this.updateSaveVersion('0')
        } else {
          // 删了原本的文件
          if (
            this.appMarketLink === '' &&
            (this.versionStatus === 1 || this.versionStatus === 2) // 待测试、测试中
          ) {
            // 没有市场链接，需要给出提示
            this.$message.error('请选择新的版本安装文件')
          } else {
            // 先判断下原来有没有安装包，原来有的话，需要给出确认框
            if (this.filename2Bak !== '') {
              this.confirmupdateSaveVersion()
            } else {
              this.updateSaveVersion('1')
            }
          }
        }
      }
    },
    // updateVersion(uploadObj) {
    //   // 没有市场链接
    //   if (this.appMarketLink === '') {
    //     if (this.filename2 !== '') {
    //       // 没删原本的文件,直接保存
    //       this.updateSaveVersion()
    //     } else if (this.filename2 === '' && this.filename === '') {
    //       // 删了，没上传安装包，提示错误信息
    //       this.$message.error('请选择新的版本安装文件')
    //     } else {
    //       // 重新上传新的安装包了
    //       this.$store.commit('addUpload', uploadObj)
    //       this.visible = false
    //     }
    //   } else {
    //     // 有应用市场链接
    //     // 原来没有安装包
    //     if (this.filename2Bak === '') {
    //       if (this.filename === '') {
    //         // 没有上传新的
    //         this.updateSaveVersion()
    //       } else {
    //         // 后来上传新的安装包了
    //         this.$store.commit('addUpload', uploadObj)
    //         this.visible = false
    //       }
    //     } else {
    //       // 原来有安装包
    //       // 原来的安装包没有删，直接保存的
    //       if (this.filename2 !== '') {
    //         this.updateSaveVersion()
    //       } else if (this.filename === '') {
    //         // 把原来的安装包删了，且没有新上传
    //         // 删了上传安装包，二次弹框
    //         this.confirmupdateSaveVersion()
    //       } else {
    //         // 把原来的安装包删了，且上传新的了
    //         this.$store.commit('addUpload', uploadObj)
    //         this.visible = false
    //       }
    //     }
    //   }
    // },
    confirmupdateSaveVersion() {
      this.$confirm('确认后会导致原版本安装文件被删除无法找回，继续操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.updateSaveVersion('1')
        })
        .catch(() => {})
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.fileList = []
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-box {
  display: flex;
  align-items: center;
}
.name-box {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 450px;
}
.el-upload {
  text-align: left;
}
.number-input-version {
  width: 80px;
  margin-right: 5px;
  margin-left: 5px;
}
::v-deep {
  .el-upload {
    width: 100%;
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #fff;
  }
  .name-unrequired {
    .el-form-item__label:before {
      content: '' !important;
    }
  }
}
.upload-input {
  // width: 40%;
  position: relative;
  display: flex;
  justify-content: space-between;
}
// ::v-deep{
//   .el-list-enter-active,
//   .el-list-leave-active {
//       transition: none;
//   }

//   .el-list-enter,
//   .el-list-leave-active {
//       opacity: 0;
//   }
// }
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /*height:600px;*/
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}
::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
.dflex {
  display: flex;
}
.progress-percent {
  flex: 1;
  font-size: 12px;
  text-align: left;
  padding-left: 50px;
  color: #999;
}

// .el-table--border, .el-table--group{

// }
// .el-table.version-table{
//   margin-left: 150px !important;
//   font-size: 12px !important;
//   height:40px;
// }

.version-table {
  display: flex;
  margin-bottom: 22px;
  .el-table {
    font-size: 12px;
  }
  .v-label {
    width: 108px;
    padding-right: 12px;
    text-align: right;
    padding-top: 15px;
  }
}
.version-table .v-label {
  padding: 0, 12px, 0, 0 !important;
}
.error-msg {
  color: red;
  font-size: 12px;
  margin-right: 20px;
}
.el-icon-delete-solid {
  margin-left: 20px;
  cursor: pointer;
  &:hover {
    color: #409eff;
  }
}
</style>
